module.exports = __webpack_public_path__ + "static/media/20.3f2a7951.jpg";